export default "__VITE_PUBLIC_ASSET__23e1ee49__"